import {ProductUpdate, SeenProductUpdatesRequest} from 'app_api/product_updates/types';
import {apiClient} from 'common/util/api-client';

const BASE_URL = `/api/app/product_updates`;

export function getProductUpdates(): Promise<ProductUpdate[]> {
  return apiClient.get<ProductUpdate[]>(BASE_URL);
}

export function markProductUpdatesAsSeen(updateIds: number[]): Promise<void> {
  const data: SeenProductUpdatesRequest = {seen: updateIds};
  return apiClient.post(`${BASE_URL}/seen`, data);
}
